import { whitelist } from "@faire/retailer-visitor-shared/initializers/AutoSignUpInitializer";
import { useSettingIsPerfAppSemDiscoverTreatment } from "@faire/retailer-visitor-shared/settings/useSettingPerfAppSemDiscover";
import { RouteMatcher } from "@faire/web--source/common/routes/RouteMatcher";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useLocation } from "react-router-dom";

import { useIsLoggedInRetailer } from "../../../lib/isLoggedInRetailer";

export const useIsEligibleForMobileLoggedOutNavWithCartSignUp = (): boolean => {
  const isPerfAppSemDiscoverPageTreatment =
    useSettingIsPerfAppSemDiscoverTreatment();
  const { isMobile } = useViewport();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const matcher = new RouteMatcher(whitelist);
  const location = useLocation();
  const isPageOnAllowedList =
    matcher.match(location?.pathname ?? "") !== undefined;

  return (
    !isPerfAppSemDiscoverPageTreatment &&
    isMobile &&
    !isLoggedInRetailer &&
    isPageOnAllowedList
  );
};
